import React from "react";
import PropTypes from 'prop-types';
import OnScreenKeyboard from "./OnScreenKeyboard/keyboard";
import StonesStore from './../stores/stonesStore';
import uuid from "uuid";
import $ from 'jquery';
import Config from './../config';

export default class QuantityTextField extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    onBlur: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value || '',
      uid: uuid.v4(),
      maxLength: 6
    };
  };

  componentDidMount () {}

  componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.focused) {
      this.setState({value: nextProps.value || ''});
      this.handleFocus();
    } else {
      this.setState({value: nextProps.value || ''});
    }
  }

  sanitizeValue = (value) => {
    let int = parseInt(value);
    let v = value;
    if (isNaN(int)) {
      int = 0;
      v = '';
    } else {
      v = int;
    }
    if(v.toString().length > this.state.maxLength) {
      v = v.toString().substring(0, this.state.maxLength);
      int = parseInt(v);
    }
    return {v, int};
  }

  triggerOnChange = (value) => {
    let val = this.sanitizeValue(value);

    this.setState({value: val.v});
    if(this.props.onChange) {
      window.setTimeout(() => this.props.onChange(val.int), 10);
    }
  };

  handleChange = (e) => {
    StonesStore.setUnsavedChanges();
    this.triggerOnChange(e.target.value);
  };

  handleBlur = (e) => {
    let val = this.sanitizeValue(e.target.value);
    if(this.props.onBlur) {
      this.props.onBlur(val.int);
    }
    this.props.toggleFocusOff && this.props.toggleFocusOff();
    if (Config.isAndroid() || Config.isIphone()) {
      setTimeout(() => {
        if (!this.props.hasFocusedFeauture) {
          $('.app-container').removeClass('app-container--android').removeClass('app-container--iphone-focus');
        }
      }, 300);
    }
    setTimeout(() => {
      document.inputFocused = false;
    }, 20);
  };

  handleFocus = (e) => {
    this.textInput.focus();
    if (Config.isAndroid()) {
      $('.app-container').addClass('app-container--android');
      !this.props.hasFocusedFeauture && this.props.toggleFocusOn && this.props.toggleFocusOn();
    } else if (Config.isIphone() && this.props.lightBoxInput) {
      $('.app-container').addClass('app-container--iphone-focus');
      !this.props.hasFocusedFeauture && this.props.toggleFocusOn && this.props.toggleFocusOn();
    }

    document.inputFocused = true;
  };

  setValue = (value) => {
    //console.log(12, value);
    this.triggerOnChange(value);
  };

  render() {
    const placeholder = this.props.placeHolder || '0';
    return (
      <div className="input-wrapper">
        <input className={this.props.className} placeholder={placeholder}
               onFocus={this.handleFocus} maxLength={this.state.maxLength}
               ref={(input) => { this.textInput = input; }}
               value={this.state.value} onChange={this.handleChange} onBlur={this.handleBlur}
               style={this.props.style} id={this.state.uid} key={this.state.uid}/>
        <OnScreenKeyboard type="numeric" inputId={this.state.uid} setValue={this.setValue} title={this.props.title}/>
      </div>
    );

  }
};



// WEBPACK FOOTER //
// ./src/components/quantityTextField.js